export default __webpack_public_path__ + "static/media/arrow-up.fc51e7d4.svg";